module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Dalmar-James-661cea0206571ca836bea34868136119.png";